import { createFileRoute } from '@tanstack/react-router'
import { useCallback } from 'react'
import { z } from 'zod'
import { DATA_ENTITIES } from '@/core/dictionary'
import {
  DataDictionaryScreen,
  type DataDictionarySearch,
} from '@/features/dictionary/routes/data-dictionary-screen'

const text = z.string().max(200)

// The tab, filter and open entry live in the address, so a link can point at
// one field or one code.
const searchSchema = z.object({
  tab: z.enum(['fields', 'codes']).default('fields'),
  entity: z.enum(DATA_ENTITIES).optional(),
  field: text.optional(),
  q: text.optional(),
  open: text.optional(),
})

// The header and the tab title come from the address (nav-config.ts).
export const Route = createFileRoute('/settings/data-dictionary')({
  validateSearch: searchSchema,
  component: DataDictionary,
})

function DataDictionary() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const onSearchChange = useCallback(
    (patch: Partial<DataDictionarySearch>) =>
      navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  )
  return <DataDictionaryScreen search={search} onSearchChange={onSearchChange} />
}
